import React from 'react';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';
import { QuotationResponse } from '@/api/bol';

export interface QuotationDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  quotation: QuotationResponse | null;
}

export const QuotationDeleteDialog: React.FC<QuotationDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  quotation
}) => {
  return (
    <DeleteConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      itemType="quotation"
      itemId={quotation?.id || ''}
    />
  );
};